import { API } from "../api";
import { setError } from "./Indicator";
import { OUT_BOUND_ORDER_LIST } from "../constants/url.constant";

export const REQUEST_OUT_BOUND_SHIPING_LIST = "REQUEST_OUT_BOUND_SHIPING_LIST";
export const SET_OUT_BOUND_SHIPING_LIST = "SET_OUT_BOUND_SHIPING_LIST";

export const setOutBoundShipingList = (data) => {
  return {
    type: SET_OUT_BOUND_SHIPING_LIST,
    payload: data
  };
};

export const outBoundShipingList = ({ limit, page }) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_OUT_BOUND_SHIPING_LIST });
    try {
      const res = await API.get(`${OUT_BOUND_ORDER_LIST}`, {
        params: {
          limit: limit,
          page: page
        }
      });

      return dispatch(setOutBoundShipingList(res));
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false,
  columns: [],
  data: [],
  totalRows: {}
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case REQUEST_OUT_BOUND_SHIPING_LIST:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case SET_OUT_BOUND_SHIPING_LIST:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count
      };
    default:
      return state;
  }
}
